function objectIdToDate(id: string) {
  return new Date(parseInt(id.substring(0, 8), 16) * 1000)
}

export default objectIdToDate
